export const ensureNoForwardSlash = (url: string): string => {
    return url.replace(/\/?(.*)/, '$1')
}
